import type { ClubFeed } from './types';

export const CHAMPIONS_ENTRY_ID = 'season:2025-26';

const findHeadline = (lastSeason: NonNullable<ClubFeed['lastSeason']>, label: RegExp): string | null =>
  lastSeason.headlineStats.find((s) => label.test(s.l))?.v ?? null;

export function championsMemoryFromClub(lastSeason: ClubFeed['lastSeason']) {
  if (!lastSeason) return null;
  const cleanSheets = findHeadline(lastSeason, /clean/i);
  const goalDifference = findHeadline(lastSeason, /difference|gd/i);

  // Name the real source inline instead of a bare "Verified" certainty claim
  // the card can't back (prior-audit P0-1, 2026-06-26). No `source` on the
  // feed ⇒ no suffix at all, rather than a fabricated one.
  const label = lastSeason.source ? `${lastSeason.label} · ${lastSeason.source}` : lastSeason.label;

  return {
    label,
    headline: lastSeason.headline,
    title: 'Arsenal champions again.',
    entryId: CHAMPIONS_ENTRY_ID,
    stats: [
      { v: String(lastSeason.row.pts), l: 'Points' },
      { v: String(lastSeason.row.w), l: 'Wins' },
      ...(goalDifference ? [{ v: goalDifference, l: 'Goal difference' }] : []),
      ...(cleanSheets ? [{ v: cleanSheets, l: 'Clean sheets' }] : []),
    ],
    scorers: lastSeason.scorers.goals,
    note: lastSeason.headline,
    detail: `${lastSeason.row.w} wins, ${lastSeason.row.d} draws and ${lastSeason.row.l} defeats. Explore the season that brought the title home.`,
  };
}
